/**
 * Theatre overview for the Surgeon and the Intensivist: whether a Theatre is
 * free, booked, closed, and whether anaesthetic cover exists.
 */
import type { BoardView, SeatView } from '@nightshift/engine/client';
import type { ReactElement } from 'react';

/** One plain sentence about the first Theatre, worded for the viewer's role. */
function firstTheatre(t: BoardView['theatre'], surgeon: boolean): string {
  if (t.closed) return `Closed today: ${t.closed}`;
  if (t.used) return 'In use this turn.';
  if (t.booked && !t.anaesthetic) return `An operation is booked and has no anaesthetic cover yet.${surgeon ? ' Waiting for the Intensivist.' : ''}`;
  if (t.booked) return 'An operation is booked and has anaesthetic cover.';
  if (t.anaesthetic) return surgeon ? 'Anaesthetic cover is ready.' : 'You are standing by.';
  return 'No anaesthetic cover yet.';
}

/** Show Theatre state to the two roles who run it; nobody else sees detail. */
export function TheatreOverview({ v }: { v: SeatView }): ReactElement | null {
  const role = v.me.role;
  if (role !== 'SURG' && role !== 'ICU') return null;
  const second = v.board.secondTheatre;
  return <section className="bd-kit" aria-label="Theatre overview">
    <h3 className="sec-title">Theatres</h3>
    <div className="kit-grid">
      <div className="kit"><span className="kit-name">Theatre</span><span className="kit-detail">{firstTheatre(v.board.theatre, role === 'SURG')}</span></div>
      {second && <div className="kit"><span className="kit-name">Second Theatre</span><span className="kit-detail">{second.closed ? `Closed today: ${second.closed}` : `${second.used ? 'In use this turn. ' : ''}Anaesthetic cover is included.`}</span></div>}
    </div>
    <p className="muted">An operation cannot go ahead without anaesthetic cover.</p>
  </section>;
}
